<template>
    <v-container>
        <div v-if="showcargando == true" id="cargando" wire:loading
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>

        <v-layout row wrap>
            <v-flex xs12 sm12 md12>
                <v-card flat class="text-xs-center ma-3 " width="100%">
                    <v-card-title class="justify-center primary">
                        <v-toolbar-title id="titulocard">Inicio de denuncia o carpeta</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-icon :color="'#FFFFFF'">mdi-school-outline</v-icon>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" md="12">
                                <vs-list>
                                    <vs-list-item :title="datosAveL.txtLabelTitulo"
                                        :subtitle="datosAveL.txtLabelDato"></vs-list-item>
                                </vs-list>
                            </v-col>
                        </v-row>
                        <v-list-item>
                            <v-list-item-action class="mr-1">SI</v-list-item-action>
                            <v-list-item-action>NO</v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider></v-divider>
                        <div v-for="(movimiento) in this.movdc" :key="movimiento.orden">
                            <v-list-item>
                                <v-list-item-action class="mr-1">
                                    <v-checkbox :on-icon="'mdi-check-circle-outline'"
                                        :off-icon="'mdi-checkbox-blank-circle-outline'" class="disable-action"
                                        v-model="movimiento.respuestaSI"></v-checkbox>
                                </v-list-item-action>
                                <v-list-item-action>
                                    <v-checkbox :on-icon="'mdi-check-circle-outline'"
                                        :off-icon="'mdi-checkbox-blank-circle-outline'" class="disable-action"
                                        v-model="movimiento.respuestaNO"></v-checkbox>
                                </v-list-item-action>
                                <v-list-item-content class="ml-1" style="color:black">
                                    {{ movimiento.nombre }}
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>
                        </div>
                    </v-card-text>
                </v-card>
            </v-flex>
            <Expediente></Expediente>
        </v-layout>
    </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import ReporteRobo from '@/services/asistenciaRobo/AsistenciaRobo.service.js';
import Expediente from '@/components/pages/detalleReporte/Movimientos/Expediente.vue';
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";

export default {
    components: {
        Expediente
    },
    props: ["tokenData"],
    data: function () {
        return {
            tipoAsistencia: [],
            showcargando: true,
            movdc: [],
            datosAveL: [],
            info: []
        }
    },
    computed: {
        ...mapState({ drawer: state => state.drawer }),
        ...mapState(['domain', 'informationPage']),
        DRAWER_STATE: {
            get() {
                return this.drawer
            },
        }
    },
    methods: {
        async ObtenerDatosAverLibVeh() {
            this.datosAveL = await ReporteRobo.DatosAsistencia(this, this.info.proceso, 1);
            for (let i in this.datosAveL) {
                for (const [key, value] of Object.entries(this.datosAveL[i])) {
                    if (typeof value == "object") {
                        this.datosAveL[i][key] = ""
                    }
                }
            }
            this.datosAveL = this.datosAveL[0]
        },
        async AvePrevMovimientosDC() {
            let respuestas = await ReporteRobo.AvePrevMovimientos(this, this.info.proceso)
            for (let i in respuestas) {
                for (const [key, value] of Object.entries(respuestas[i])) {
                    if (typeof value == "object") {
                        respuestas[i][key] = ""
                    } else {
                        if (key == "etiqueta2") {
                            respuestas[i][key] = '$' + parseInt(value).toFixed(2)
                        } else if (key == "respuestaSI" || key == "respuestaNO") {
                            respuestas[i][key] = respuestas[i][key].toLowerCase() === 'true';
                        } else {
                            respuestas[i][key] = value.toString()
                        }
                    }
                }
            }
            this.movdc = respuestas.filter((mov) => {
                return mov.visible === "true"
            })
            this.showcargando = false;
        }
    },
    async mounted() {
        this.showcargando = true;
        this.info = await ReporteRobo.EncabezadoReporte(this);
        this.info.LibVeh = this.info.LibVeh == 1 ? true : false;
        this.info.ApodLeg = this.info.ApodLeg == 1 ? true : false;
        var infoP = {
            proceso: parseInt(this.info.proceso),
            libVeh: this.info.LibVeh,
            apodLeg: this.info.ApodLeg
        };
        await MetodosGenerales.guardarEnSesionInfoReporte(infoP, "info");
        await this.ObtenerDatosAverLibVeh();
        await this.AvePrevMovimientosDC();
    }
}

</script>